<template>
  <form>
    <v-card class="height-auto">
      <v-toolbar dark color="deep-purple lighten-1">
        <v-toolbar-title> Select Student Uniform Size</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="$emit('closemodal')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-row key="1" v-if="studentData.id">
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">Student Name</div>
                <div class="text-button mb-1">
                  {{ studentData.studentEnrollment.studentName }}
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">Gender</div>
                <div class="text-button mb-1">
                  {{ studentData.studentEnrollment.gender }}
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">Class</div>
                <div class="text-button mb-1">
                  {{ studentData.studentClass.name }}
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">Section</div>
                <div class="text-button mb-1">
                  {{ studentData.studentSection.name }}
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Franchisee Name
                </div>
                <div class="text-button mb-1">
                  {{ studentData.franchisee.companyName }}
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">Academic Year</div>
                <div class="text-button mb-1">
                  {{ studentData.franchiseeAcademicYear.academicYear }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <div class="holder">
          <v-tabs
            v-model="selectUniformSizeTab"
            background-color="deep-purple lighten-1"
            center-active
            dark
          >
            <v-tabs-slider color="Blue"></v-tabs-slider>
            <v-tab v-for="key in Object.keys(uniforms)" v-bind:key="key">
              {{ key }}
            </v-tab>
            <v-tab-item v-for="key in Object.keys(uniforms)" v-bind:key="key">
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <v-tabs>
                    <v-tabs-slider
                      color="deep-purple lighten-1"
                    ></v-tabs-slider>
                    <v-tab
                      v-for="subType in Object.keys(uniforms[key])"
                      v-bind:key="subType"
                    >
                      {{ uniforms[key][subType].subType }}
                    </v-tab>
                    <v-tab-item
                      v-for="subType in Object.keys(uniforms[key])"
                      v-bind:key="subType"
                    >
                      <v-row>
                        <v-col cols="8" md="8" sm="8">
                          <div class="d-flex justify-space-between caption">
                            <div>
                              <div class="black--text text-subtitle-2 mb-1">
                                size
                              </div>
                              <div class="text-button mb-1">
                                <v-autocomplete
                                  class="my-0 py-1"
                                  placeholder="Select Size"
                                  name="classSelect"
                                  required
                                  :items="
                                    uniforms[key][subType].productApparels
                                  "
                                  return-object
                                  key="id"
                                  v-model="
                                    uniforms[key][subType]
                                      .selectedProductDetails
                                  "
                                  item-text="size"
                                >
                                </v-autocomplete>
                              </div>
                            </div>
                            <template
                              v-if="
                                uniforms[key][subType].selectedProductDetails
                              "
                            >
                              <div
                                class="col-md-2"
                                v-if="
                                  uniforms[key][subType].selectedProductDetails
                                    .chest
                                "
                              >
                                <div class="black--text text-subtitle-2 mb-1">
                                  Chest
                                </div>
                                <div class="black--text button mb-1">
                                  {{
                                    uniforms[key][subType]
                                      .selectedProductDetails
                                      ? uniforms[key][subType]
                                          .selectedProductDetails.chest || '-'
                                      : '-'
                                  }}
                                </div>
                              </div>

                              <div
                                class="col-md-2"
                                v-if="
                                  uniforms[key][subType].selectedProductDetails
                                    .frontLength
                                "
                              >
                                <div class="black--text text-subtitle-2 mb-1">
                                  Front Length
                                </div>
                                <div class="black--text button mb-1">
                                  {{
                                    uniforms[key][subType]
                                      .selectedProductDetails
                                      ? uniforms[key][subType]
                                          .selectedProductDetails.frontLength ||
                                        '-'
                                      : '-'
                                  }}
                                </div>
                              </div>

                              <div
                                class="col-md-2"
                                v-if="
                                  uniforms[key][subType].selectedProductDetails
                                    .shoulderSize
                                "
                              >
                                <div class="black--text text-subtitle-2 mb-1">
                                  Shoulder Size
                                </div>
                                <div class="black--text button mb-1">
                                  {{
                                    uniforms[key][subType]
                                      .selectedProductDetails
                                      ? uniforms[key][subType]
                                          .selectedProductDetails
                                          .shoulderSize || '-'
                                      : '-'
                                  }}
                                </div>
                              </div>
                              <div
                                class="col-md-2"
                                v-if="
                                  uniforms[key][subType].selectedProductDetails
                                    .waistRelax
                                "
                              >
                                <div class="black--text text-subtitle-2 mb-1">
                                  Waist Relax
                                </div>
                                <div class="black--text button mb-1">
                                  {{
                                    uniforms[key][subType]
                                      .selectedProductDetails
                                      ? uniforms[key][subType]
                                          .selectedProductDetails.waistRelax ||
                                        '-'
                                      : '-'
                                  }}
                                </div>
                              </div>
                              <div
                                class="col-md-2"
                                v-if="
                                  uniforms[key][subType].selectedProductDetails
                                    .waistStretch
                                "
                              >
                                <div class="black--text text-subtitle-2 mb-1">
                                  Waist Stretch
                                </div>
                                <div class="black--text button mb-1">
                                  {{
                                    uniforms[key][subType]
                                      .selectedProductDetails
                                      ? uniforms[key][subType]
                                          .selectedProductDetails
                                          .waistStretch || '-'
                                      : '-'
                                  }}
                                </div>
                              </div>
                            </template>
                          </div>
                        </v-col>
                        <v-col cols="4" md="4" sm="4">
                          <div>
                            <img
                              v-if="
                                uniforms[key][subType].selectedProductDetails
                              "
                              class="img-fluid"
                              width="500"
                              height="600"
                              :src="`${uniforms[key][subType].selectedProductDetails.sizeUrl}`"
                              :alt="`not found`"
                            />
                          </div>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>
          <v-btn
            @click="saveSelectedProducts()"
            color="success"
            class="align-button px-3 ml-1 ma-1 mt-5"
            min-width="0"
            absolute
            right
          >
            <v-icon small> mdi-pencil </v-icon>
            <span class="ml-1 text-strong">Save</span>
          </v-btn>
        </div>

        <hr />
      </v-card-text>
      <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="saveSelectedProducts()" color="success" class="px-2 ml-1 ma-1 mt-2" min-width="0" absolute right> <v-icon small> mdi-pencil </v-icon> <span class="ml-1">Save</span> </v-btn>
          </v-card-actions> -->
    </v-card>
  </form>
</template>
<script>
// import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
// import csvjson from 'csvjson'
// import csvtojsonV2 from 'csvtojson'
// import moment from 'moment'

export default {
  name: 'selectSizeModal',
  components: {},
  props: {
    studentData: Object
  },
  data () {
    return {
      uniforms: {},
      selectUniformSizeTab: null,
      apparelTypes: []
    }
  },
  created: function () {
    console.log(this.studentData)
    this.getStudentUniforms()
  },
  methods: {
    getStudentUniforms: async function () {
      try {
        let uniforms = await http.get(
          `${constants.API_URL}/api/product/size-by-user-application`,
          {
            params: {
              enquiryID: this.studentData.studentEnrollment.enquiry.id,
              academicYearID: this.studentData.franchiseeAcademicYear.id,
              gender: this.studentData.studentEnrollment.gender,
              franchiseeID: this.studentData.franchisee.id
            }
          }
        )
        console.log(uniforms.data)
        this.uniforms = uniforms.data
        let apparelTypes = await http.get(
          `${constants.API_URL}/api/product/apparel-types-application?franchiseeID=${this.studentData.franchisee.id}`
        )
        this.apparelTypes = apparelTypes.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.messagec
        this.errMsg(errorMessage)
      }
    },
    saveSelectedProducts: async function () {
      try {
        var studentAppreals = []
        var enquiryDetails = this.studentData
        let selectedProducts = []
        for (let key in this.uniforms) {
          for (let obj of this.uniforms[key]) {
            if (obj.selectedProductDetails) {
              selectedProducts.push(obj.selectedProductDetails)
            } else {
              return this.$buefy.toast.open({
                message: 'Please select all uniform sizes.',
                type: 'is-danger',
                duration: 4000
              })
            }
          }
        }

        studentAppreals = []

        selectedProducts.map((prod) => {
          studentAppreals.push({
            enquiryID: enquiryDetails.studentEnrollment.enquiry.id,
            studentAdmissionID: enquiryDetails.id,
            classID: enquiryDetails.studentClass.id,
            productID: prod.productID,
            apparelTypeID: prod.productTypeID,
            size: prod.size,
            quantity: prod.quantity
          })
        })
        // API call to save the selection
        await http.post(`${constants.API_URL}/api/product/student-appreal`, {
          franchiseeID: enquiryDetails.franchisee.id,
          academicYearID: enquiryDetails.academicYearID,
          studentAppreals: studentAppreals
        })
        this.$buefy.toast.open({
          message: 'Successfully updated the uniform size selection.',
          type: 'is-success',
          duration: 5000
        })
        this.$emit('closemodal')
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('saveSelectedProducts', errorMessage)
        this.errMsg(errorMessage)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>
.height-auto {
  height: 100vh;
  overflow-y: scroll;
}
.holder {
  position: relative;
}
.align-button {
  position: absolute;
  right: 9px;
  top: -14px;
}
.text-strong {
  font-size: 18px;
  font-weight: 600;
}
</style>
